import React, {useMemo} from "react";
import {SelectChipInput} from "~/apps/core/ui/ChipInput/SelectChipInput"



export type PassTypeChipInputProps = {
    value?: string
    onChange?: (value: string) => any
    disabled?: boolean
}


export const PassTypeChipInput = (props: PassTypeChipInputProps) => {
    const options = [
        {
            title: "Автомобильный",
            value: "car",
        },
        {
            title: "Пешеходный",
            value: "pedestrian"
        },
        {
            title: "Все",
            value: null
        }
    ]

    const title = "Тип";
    const label = useMemo(() => {
        return options.find(x => x.value == props.value)?.title || title;
    }, [options, props.value])

    return (
        <SelectChipInput {...props} title={title} label={label} options={options}/>
    )
}